import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { PAWorkFlowStepsModel } from "@/store/models/paWorkFlow/paWorkFlowStepsDTO";
let WorkFlowStepConfigurationComponent = /** @class */ (() => {
    var _a;
    let WorkFlowStepConfigurationComponent = class WorkFlowStepConfigurationComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Step Configuration";
            this.formName = "";
            this.stepDuration = 0;
        }
        closeStepConfig() {
            this.formName = "";
            this.stepDuration = 0;
            this.$emit("close-step-config");
        }
        get isFormSelected() {
            return this.workflowStepConfig.paReviewFormId != null;
        }
        findForm(formName) {
            return this.stepForms.find((form) => form.value.toLowerCase().replace(/\s/g, "") === formName.toLowerCase().replace(/\s/g, ""));
        }
        findFormById(formId) {
            return this.stepForms.find((form) => form.id === formId);
        }
        setForm() {
            this.validate("stepConfigObserver").then((response) => {
                if (response) {
                    if (this.formName !== "") {
                        const foundForm = this.findForm(this.formName);
                        if (foundForm) {
                            this.workflowStepConfig.paReviewFormId = foundForm.id;
                        }
                        this.formName = "";
                    }
                    this.workflowStepConfig.stepDuration = parseInt(this.stepDuration.toString());
                    this.$emit("workflow-step-config-updated", this.workflowStepConfig);
                }
            });
        }
        removeForm() {
            this.workflowStepConfig.paReviewFormId = null;
            this.formName = "";
        }
        created() {
            if (this.workflowStepConfig.paReviewFormId != null) {
                const foundform = this.findFormById(this.workflowStepConfig.paReviewFormId);
                this.formName = foundform.value;
            }
            this.stepDuration = this.workflowStepConfig.stepDuration;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], WorkFlowStepConfigurationComponent.prototype, "stepForms", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAWorkFlowStepsModel !== "undefined" && PAWorkFlowStepsModel) === "function" ? _a : Object)
    ], WorkFlowStepConfigurationComponent.prototype, "workflowStepConfig", void 0);
    WorkFlowStepConfigurationComponent = __decorate([
        Component({
            name: "WorkFlowStepConfigurationComponent",
        })
    ], WorkFlowStepConfigurationComponent);
    return WorkFlowStepConfigurationComponent;
})();
export default WorkFlowStepConfigurationComponent;
